import { render, staticRenderFns } from "./InvoiceBuyPage.vue?vue&type=template&id=00c272c2"
import script from "./InvoiceBuyPage.vue?vue&type=script&lang=js"
export * from "./InvoiceBuyPage.vue?vue&type=script&lang=js"
import style0 from "./InvoiceBuyPage.vue?vue&type=style&index=0&id=00c272c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports